import { NODE_TYPE } from 'shared/constants/slate';

import { isFromStartToStartOfBlock, } from '../utils';



/*
 * EditList and EditBlockquote has a normalization rule
 * that requires an inner block. This seems to confuse
 * Slate when deleting into/over them because Slate deletes the
 * inner block only and normalization rule re-creates
 * a new inner block, which results in not deleting anything. :\
 * We want to handle them as best as we can.
 */
const PatchDeleteIntoTargetTypes = (opts = {}) => ({

  onKeyDown(event, data, change) {
    const { state } = change;

    // Default behavior seems fine when selection not
    // from start to start of blocks.
    if (!isFromStartToStartOfBlock(state)) {
      return;
    }

    const { document: doc, startBlock, endBlock, } = state;
    const { li, blockquote, codeBlock } = NODE_TYPE;
    const { targetTypes = [li, blockquote, codeBlock] } = opts;

    if (state.isExpanded) {

      // Noop.
      // Should now be handled by
      // PatchEditWhileExpanded plugin instead.

    } else {

      if (data.key !== 'backspace') {
        return;
      }

      const prevBlock = doc.getPreviousBlock(startBlock.key);
      if (!prevBlock) {
        return;
      }

      // We only care about deleting into target block types.
      // Just parent block, not furthest block.. because `li`?
      const prevBlockParent = doc.getParent(prevBlock.key);
      if (!targetTypes.includes(prevBlockParent.type)) {
        return;
      }

      // ... except if we are already in one of target block
      // types, then let the plugin handle itself.
      const startBlockParent = doc.getParent(startBlock.key);
      if (targetTypes.includes(startBlockParent.type)) {
        return;
      }

      // This is the case where EditList and EditBlockquote seem to
      // keep the previous list or blockquote around because backspace
      // only deletes the inner paragraph block inside prevBlock.
      const isDeletingIntoEmtpyBlockWithContent = (
        prevBlock.isEmpty
        && !endBlock.isEmpty
      );

      switch (prevBlockParent.type) {
        case li:
          if (!isDeletingIntoEmtpyBlockWithContent) {
            // Default behavior is fine here.
            return;
          }

          const endBlockParent = doc.getParent(endBlock.key);
          if (endBlockParent.type === li) {
            // Deleting inside list, let default behavior apply.
            return;
          }

          const precedingEmptyLI = prevBlockParent;
          const listAnchor = doc.getParent(precedingEmptyLI.key);
          if (listAnchor.nodes.first().key === precedingEmptyLI.key) {
            // Deleting into first and last list item, so
            // delete the whole list. This can be a list nested inside
            // another list..
            return change.removeNodeByKey(listAnchor.key);
          }

          return change.removeNodeByKey(precedingEmptyLI.key);

        case blockquote:
        case codeBlock:
          const lineBlocksInside = prevBlockParent.getBlocks();
          const lastLineBlock = lineBlocksInside.last();
          const isLastLineEmpty = lastLineBlock.text.length === 0;

          if (!isLastLineEmpty) {
            return;
          }

          if (lineBlocksInside.size === 1) {
            // Deleting into last and only line that is empty,
            // so remove the whole parent block.
            return change.removeNodeByKey(prevBlockParent.key);
          }

          // Remove last line that is empty.
          return change.removeNodeByKey(lastLineBlock.key);

        default:
          return;
      } // switch end
    } //  if-else end

  }
});


export default PatchDeleteIntoTargetTypes;



// WEBPACK FOOTER //
// ./src/components/slate/plugins/PatchDeleteIntoTargetTypes.js